import { useState } from "react";

export const ProductFilterItem = (props) => {
  const [selected, setSelected] = useState("");
  const [checked, setChecked] = useState("");
  const values = props.item[1];
  const condition = values.length < 3 && $.inArray("ano", values) !== -1;

  const options = values.map((value) => {
    const name = typeof value === "object" ? value.name : value;
    const content = typeof value === "object" ? value.content : value;
    const keySalt = typeof value === "object" ? value.content : value;

    return (
      <option key={props.item[0] + props.item[1] + keySalt} value={content}>
        {name}
      </option>
    );
  });

  const selectBox = (
    <div style={{ margin: "3px 10px 5px 0", maxWidth: 193 }}>
      <select
        className="form-control"
        onChange={handleOptionChange}
        value={selected}
        disabled={props.filterInProgress}
        style={{
          color: selected ? "rgb(45, 165, 20)" : "#1861B2",
          fontWeight: "bold",
        }}
      >
        <option value="">{props.item[0]}</option>
        {options}
      </select>{" "}
    </div>
  );

  const checkBox = (
    <div className="checkbox-param" style={{ margin: "9px 4px 0 0" }}>
      <input
        type="checkbox"
        name={props.item[0]}
        id={props.item[0]}
        value="ano"
        checked={checked}
        onChange={handleCheckboxChange}
        disabled={props.filterInProgress}
      />
      <label htmlFor={props.item[0]}>{props.item[0]}</label>
    </div>
  );

  if (condition) {
    return checkBox;
  } else {
    return selectBox;
  }

  function handleOptionChange(e) {
    setSelected(e.target.value);

    props.filter(props.item[0], e.target.value);
  }

  function handleCheckboxChange(e) {
    setChecked(e.target.checked);

    props.filter(props.item[0], e.target.checked ? "ano" : "");
  }
};
